import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { useCurrentWorkspace } from '@gripp/shared-logic';
import { Colors } from '@gripp/shared-ui';
import { StyleSheet, Text, View } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { CreateProductForm } from './createProductForm';

export const CreateProductButton = () => {
  const currentWorkspace = useCurrentWorkspace();

  return (
    currentWorkspace && (
      <View style={styles.createProductContainer}>
        <ModalButton
          label=""
          omitPadding={true}
          customButton={
            <View style={{ flexDirection: 'row' }}>
              <MaterialCommunityIcons
                name="plus"
                color={Colors.blackText}
                size={16}
                style={styles.icon}
              />
              <Text style={styles.label}>Create Product</Text>
            </View>
          }
          buttonStyle={styles.createProductButton}
          modalComponent={({ onComplete }) => {
            return (
              <CreateProductForm
                onComplete={onComplete}
                workspaceId={currentWorkspace.id}
              />
            );
          }}
          containerStyle={styles.modalContainer}
        />
      </View>
    )
  );
};

const styles = StyleSheet.create({
  createProductContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,
  },
  createProductButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 151,
    height: 32,
    backgroundColor: Colors.white,
    borderRadius: 16,
  },
  icon: {
    marginRight: 4,
  },
  label: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: -0.25,
  },
  modalContainer: {
    flex: 1,
    alignSelf: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 560,
    maxHeight: 193,
    borderRadius: 12,
    backgroundColor: Colors.primaryGrayBackground,
  },
});
